import { Component, OnInit, Input } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Router } from '@angular/router';
import { BankAccountRole, EnumHelper, BankAccountType } from 'common';
import { BankAccountsListGroupedByInstitutionData } from '../../bank/bank.model';
import { readWrite } from '../../user/user-permission/user-permission.data';
import { UserPermissionService } from '../../user/user-permission/user-permission.service';
import { BrokerData } from '../broker.model';

@UntilDestroy()
@Component({
    selector: 'ifb-broker-bank-account-widget',
    templateUrl: './broker-bank-account-widget.component.html',
    styleUrls: ['./broker-bank-account-widget.component.scss'],
    standalone: false
})
export class BrokerBankAccountWidgetComponent implements OnInit {
  readWriteBanks = false;

  @Input()
  broker: BrokerData;

  @Input()
  accountsGroupedByInstitution: BankAccountsListGroupedByInstitutionData;

  readonly BankAccountRole = BankAccountRole;

  constructor(
    private readonly router: Router,
    private readonly userPermissionService: UserPermissionService
  ) { }

  ngOnInit(): void {
    this.userPermissionService.granted([readWrite('servicing-bank-accounts')])
      .pipe(untilDestroyed(this))
      .subscribe(res => {
        this.readWriteBanks = res;
      });
  }

  getBankAccountType(bankAccountType: string): string {
    return bankAccountType ? EnumHelper.getNameFromValue(BankAccountType, bankAccountType) : null;
  }

  bankAccountDetailsLink(bankAccountId: number): void {
    this.router.navigate([`broker/${this.broker.id}/banks/${bankAccountId}`]);
  }
}
